import { render, staticRenderFns } from "./TagsCell.vue?vue&type=template&id=bec9e582"
import script from "./TagsCell.vue?vue&type=script&lang=js"
export * from "./TagsCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports